import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 26 25",
  class: "hadrian-icons dots"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g transform=\"rotate(90 6.15 9.15)\" data-v-4449ee6c><path fill=\"#5D5C5C\" fill-rule=\"nonzero\" d=\"M2.01 4a1.94 1.94 0 110-3.88 1.94 1.94 0 010 3.88\" data-v-4449ee6c></path></g><g transform=\"rotate(90 2.4 12.9)\" data-v-4449ee6c><path fill=\"#5D5C5C\" fill-rule=\"nonzero\" d=\"M2.01 4a1.94 1.94 0 110-3.88 1.94 1.94 0 010 3.88\" data-v-4449ee6c></path></g><g transform=\"rotate(90 -1.35 16.65)\" data-v-4449ee6c><path fill=\"#5D5C5C\" fill-rule=\"nonzero\" d=\"M2.01 4a1.94 1.94 0 110-3.88 1.94 1.94 0 010 3.88\" data-v-4449ee6c></path></g>", 3)
  ]))]))
}